export default "assets/images/logo-2ab25652.png";